import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'itemCategory/'

const initialState = {
    categories: [],
    cateSetupData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getCategorySetupData = createAsyncThunk('itemcate/gcsd', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getCategorySetupData')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addNewItem = createAsyncThunk('itemcate/anc', async (cateData, thunkAPI) => {
    try {
        await axios.post(API_URL + 'addNewCategory', cateData)
        return cateData
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAllICategories = createAsyncThunk('itemcate/gac', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getAllCategory')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteCategory = createAsyncThunk('itemcate/dC', async (itemCode, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'deleteCategory', itemCode)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const itemsCategorySlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.categories = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getCategorySetupData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getCategorySetupData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.cateSetupData = action.payload
            })
            .addCase(getCategorySetupData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(addNewItem.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addNewItem.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.categories.push(action.payload)
            })
            .addCase(addNewItem.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getAllICategories.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllICategories.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.categories = action.payload
            })
            .addCase(getAllICategories.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = itemsCategorySlice.actions

export default itemsCategorySlice.reducer